export default __webpack_public_path__ + "static/media/Cybersec.9b3efa67.png";